import { Alert, AntdList, Avatar, Button, Empty, Icons, Input, Show } from "@pankod/refine-antd";
import { IResourceComponentsProps, useCustomMutation, useGetIdentity } from "@pankod/refine-core";
import { IUser, chatModel } from "interfaces";
import { useState } from "react";
import { API_PATH, OPENAI_LOGO_PATH, RESOURCE_PATH } from "scripts/site";
const { Search } = Input;

export const SecurityAssessmentList: React.FC<IResourceComponentsProps> = () => {
  const [chatData, setChatData] = useState<chatModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { mutate } = useCustomMutation();
  const [inputValue, setInputValue] = useState('');
  // const [fileContent, setFileContent] = useState('');

  // useEffect(() => {
  //   async function fetchFile() {
  //     try {
  //       const response = await fetch('./sample.txt');
  //       const text = await response.text();
  //       setFileContent(text);
  //       console.log(text);
  //     } catch (error) {
  //       console.error('Error fetching file:', error);
  //     }
  //   }
  //   fetchFile();
  // }, []);

  const apiCall = (userText: string) => {
    if (!userText) {
      return;
    }

    setIsLoading(true);
    // Clear the chat history if there were any errors occured
    if (chatData.some(c => c.error)) {
      chatData.splice(0);
      setChatData(chatData);
    }

    chatData.push({
      actor: "user",
      conversation: {
        contextual: userText,
        standard: userText
      },
      error: false
    });
    setChatData(chatData);
    //setConversationText("");    
    setInputValue('');

    mutate({
      url: API_PATH + "/" + RESOURCE_PATH.SECURITYCOPILT,
      method: "post",
      values: {
        chatContext: chatData,
        query: userText
      }
    },
      {
        onSuccess: (data, variables, context) => {
          chatData.push({
            actor: "assistant",
            conversation: {
              contextual: data?.data?.contextual,
              standard: data?.data?.standard,
            },
            error: false
          });
          setChatData(chatData);
          setIsLoading(false);
        },
        onError: (data, variables, context) => {
          //if (data.statusCode === 403) {
          chatData.push({
            actor: "assistant",
            conversation: {
              contextual: data?.statusCode + " - " + data?.response?.statusText + ": " + data?.response?.data?.message,
              standard: data?.statusCode + " - " + data?.response?.statusText + ": " + data?.response?.data?.message,
            },
            error: true
          });
          setChatData(chatData);
          setIsLoading(false);
          //}
        }
      }
    );
  }

  const { data } = useGetIdentity();
  const user = data as IUser;
  const userAlias = user?.name?.split("@")[0] ?? "User";

  return (
    <Show
      canDelete={false}
      headerProps={{
        backIcon: false,
        title: "Security Co-pilot",
        extra: chatData.length > 0 && <Button danger icon={<Icons.ClearOutlined />} onClick={() => { setChatData([]) }}>Clear</Button>
      }}>

      <Alert message={
        <>Security co-pilot conducts automated application security assessments by gathering all the required details about the application from the user by asking a series of questions based on security policies, guidelines and check-lists. Finally, provides the summary of the security assessment, rates the app and generates security recommendations to the user. Access the detailed article
          <a target="_blank" rel="noopener noreferrer" href="https://helium.innovatewithtcs.com/#/accelerators/article/show/f5e3b730-1fb7-4bf6-ba6f-461d96242d92"> here.</a>

        </>
      }
        type="info" showIcon={false} banner style={{ marginBottom: 20 }}></Alert>

      <div
        id="scrollableDiv"
        style={{
          maxHeight: 500,
          overflow: 'auto',
          marginBottom: 20,
          //padding: '0 16px',
          //border: '1px solid rgba(140, 140, 140, 0.35)',
        }}
      >
        {chatData.length > 0 ?
          <AntdList
            loading={isLoading}
            itemLayout="vertical"
            pagination={false}
            dataSource={chatData}
            renderItem={(item) => (
              item.actor === "assistant"
                ? <AntdList.Item style={{ border: "none" }}>
                  <AntdList.Item.Meta
                    avatar={<Avatar src={OPENAI_LOGO_PATH} />}
                    title={"GPT-4"}
                    description={<>
                      {
                        item.conversation.standard
                          .split(/(?:\r\n|\r|\n)/g)
                          .map((text, index) => <>{text}<br /></>)
                      }

                    </>} />
                </AntdList.Item>
                : <AntdList.Item style={{ border: "none" }}>
                  <AntdList.Item.Meta
                    avatar={<Avatar src={"user.png"} />}
                    title={userAlias}
                    description={item.conversation.standard} />
                </AntdList.Item>
            )}
          >
          </AntdList>
          : <Empty description="No conversations" image={Empty.PRESENTED_IMAGE_DEFAULT}></Empty>}
      </div>

      <Search
        placeholder="Inquire about your ticket/case status or get help with any process."
        enterButton={<>Send  <Icons.SendOutlined /> </>}
        size="large"
        loading={isLoading}
        value={inputValue}
        required
        onChange={(e) => setInputValue(e.target.value)}
        onSearch={apiCall}
      />
    </Show>
  );
};